export default class PlanInfoProvider {
  static keyFactSheet(carrierCode) {
    if (carrierCode === 'UFW' || carrierCode === 'UW') {
      return 'Uniti-Fixed-Wireless-Broadband-Service-Fact-Sheet.pdf'
    }
    if (carrierCode === 'OF' || carrierCode === 'NB') {
      return 'NBN-Fact-Sheet-final.pdf'
    }
    if (carrierCode === 'OC') {
      return 'Opticomm-Fact-Sheet.pdf'
    }
    if (carrierCode === 'SM') {
      return 'Skymuster-Fact-Sheet.pdf'
    }
    if (carrierCode === 'SMP') {
      return 'SkymusterPlus-Fact-Sheet.pdf'
    }
    return 'Broadband-Fact-Sheet.pdf'
  }

  static planDescription(download, upload) {
    let string = ''

    if (download === 12)
      string =
        'Best for basic internet browing and social media<br /><strong>(1-2 users)</strong>'
    if (download === 25) string = 'Great for singles and couples'
    if (download === 50)
      string = 'Best for basic internet browsing and social media '
    if (download === 100 && upload === 20)
      string = 'Best for HD video, music streaming and online gaming '
    if (download === 100 && upload === 40)
      string = 'Best for regular video calls and large file downloads'
    if (download === 150)
      string = 'Perfect for families and households with multiple users'
    if (download === 250)
      string = 'Best for 4K video, music streaming and online gaming '
    if (download === 500 || download === 1000)
      string = 'Best for 8K video, multiple video conferencing, good for small businesses'
    return string
  }

  static smpPlanDescription(quota) {
    let string = ''

    if (quota === 25)
      string = 'Great for singles using the internet during peak hours'
    if (quota === 50)
      string = 'Perfect for households with 2-3 users during the peak hours'
    if (quota === 100)
      string = 'Perfect for households with multiple users during peak hours'
    if (quota === 150)
      string =
        'Perfect for families and households with multiple users during peak hours'
    return string
  }

  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  static planFeatured(download, upload, carrierCode, promoCode = '') {
    switch (carrierCode) {
      case 'SM':
        return download === 65
      case 'OC':
        return download === 100 && upload === 20
      case 'SMP':
        return download === 200
      default:
        return download === 50 && upload === 20
    }
  }

  static bizDescription(download, upload) {
    let desc = []

    if (download === 50 && upload === 20) {
      desc = ['Up to 5 users','HD video streaming','Downloading large files']
    }
    if (download === 100 && upload === 40) {
      desc = ['6 or more users','4K video streaming','Faster uploads and downloads']
    }
    if (download === 250 && upload === 25) {
      desc = ['6 or more users','8K video streaming','Multiple video conferences','Cloud applications']
    }
    if (download === 1000 && upload === 50) {
      desc = ['Up to 20 users','8K video streaming','Multiple video conferences','Cloud applications']
    }
    if (download === 500 && upload === 100) {
      desc = ['Up to 20 users','8K video streaming','Multiple video conferences','Cloud applications']
    }
    if (download === 1000 && upload === 400) {
      desc = ['Up to 50 users','Multiple video conferences','Fast large file downloads and uploads','Cloud applications']
    }
    if (download === 100 && upload === 100) {
      desc = ['Up to 50 users','Multiple video conferences','Fast large file downloads and uploads','Cloud applications']
    }
    if (download === 200 && upload === 200) {
      desc = ['Up to 50 users','Multiple video conferences','Fast large file downloads and uploads','Cloud applications']
    }


    return desc
  }
}
